// extracted by mini-css-extract-plugin
module.exports = {"graphContainer":"Chord_graphContainer__23VH9","chordId":"Chord_chordId__GlH5k"};